export default __webpack_public_path__ + "static/media/group-3-mobile-img5.e6f3d405.png";